import { render, staticRenderFns } from "./PermissionsTreeList.vue?vue&type=template&id=9b5bba72&scoped=true"
import script from "./PermissionsTreeList.vue?vue&type=script&lang=js"
export * from "./PermissionsTreeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b5bba72",
  null
  
)

export default component.exports